export enum SubTipoHistoricoEnum {
	ADMISSAO_DIGITAL_INICIADA = 1,
	ADMISSAO_DIGITAL_REINICIADA = 2
}
